import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = ({ style }) => (
  <path
    style={style}
    d="M48.01,25.46c-0.77,12.68-11.3,22.56-24,22.54h-0.23L8.65,33.89l0,0L8.3,33.56l5.37-2.62l3.26-1.6l0,0l2-1
l0.44-0.21l1.27-0.62l1.79-0.87l1.58-0.73l0,0l1.95-1l0.84-0.41l0.57-0.28h0.05l1.05-0.52l0.83-0.4l0.92-0.45l0.89-0.44l0.9-0.41
l0.82-0.4l2.42-1.18l0,0l4.43-2.17l0,0L48.01,25.46z"
  />
);

const XenomorphAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.AVATAR_7}
    renderShadow={renderShadow}
  >
    <>
      <path
        style={{ fill: '#666666' }}
        d="M5.01,24.91c0,3.6,4.51,7.2,12.61,0c3-2.71,21.35,5.13,24.31-2.7c0.83-2.22-5.38-8.16-14.41-9
	C17.58,12.27,5.01,21.68,5.01,24.91z"
      />
      <path
        style={{ fill: '#888888' }}
        d="M15.26,22.51c-3.34,1.23-6.69,1.64-10,2.83c1.3,1.63,1.82,2.41,2.3,3.61c0.09,0.23,1.54,0.63,1.61,0.84
	C9.23,30,8.26,31.11,8.31,31.3c0.24,0.99,0.17,1.3,0.04,1.76c-0.05,0.18-0.19,0.59,0,0.77c0.49,0.49,2.25-1.48,5.4-2.31
	c1.88-0.5,3.87,0,3.85-0.82c-0.65-1.22-1.19-2.5-1.59-3.82C15.6,25.45,15.35,23.99,15.26,22.51z"
      />
      <path
        style={{ fill: '#666666' }}
        d="M13.08,24.91l0.64,6.61c0,0,5.14,0.33,8.13,0.87h0.17c0.56,0.08,1.11,0.23,1.64,0.44l0,0
	c0.08,0.03,0.16,0.08,0.22,0.14c1.1,0.79,2.31,1.39,3.6,1.8l0.1-0.06l3.43-2.1l0.26-0.16l1.35-0.84l0.42-0.26l0,0l1.66-1
	c-0.12-0.35-0.29-0.69-0.49-1l-0.1-0.16c-0.38-0.58-0.91-1.04-1.53-1.35c-0.06-0.04-0.12-0.07-0.19-0.09
	c-0.13-0.05-0.26-0.09-0.39-0.12c-0.41-0.1-0.81-0.23-1.2-0.39l-0.26-0.12c-0.3-0.15-0.59-0.32-0.85-0.53
	c-0.06-0.04-0.11-0.09-0.16-0.14c-0.33-0.32-0.38-0.58-0.23-0.62s0.26-0.26,2.38-0.13S19.4,22.23,19.4,22.23L13.08,24.91z"
      />
      <path
        style={{ fill: '#444444' }}
        d="M27.3,35c-2.24-0.34-3.74-2.27-5.25-3.78c-1.9-2.02-4.07-3.78-6.44-5.22c-0.25-0.14,0-0.53,0.23-0.38
	c2.08,1.23,4,2.72,5.7,4.44c1.69,1.64,3.41,4.11,5.88,4.48c0.29,0,0.17,0.48-0.12,0.44L27.3,35z"
      />
      <path
        style={{ fill: '#444444' }}
        d="M19.72,28.94c0.33,0.14,0.67,0.25,1,0.36c3.4,1.14,7.09,1.42,10.22,3.29h0.05l0.26-0.16
	c0.02-0.03,0.02-0.07,0-0.1l0,0c-0.01-0.06-0.05-0.11-0.1-0.13c-0.36-0.22-0.73-0.41-1.1-0.59c-3.22-1.53-6.9-1.79-10.21-3.1l0,0
	C19.57,28.42,19.47,28.84,19.72,28.94z"
      />
      <path
        style={{ fill: '#444444' }}
        d="M15.59,26.11c2.09,0.52,4.26,0.68,6.41,0.47c0.32,0,0.32-0.54,0-0.5c-2.1,0.21-4.22,0.06-6.27-0.46
	C15.41,25.55,15.28,26.03,15.59,26.11z"
      />
      <path
        style={{ fill: '#444444' }}
        d="M27.77,28.51c1.42,1.3,3.06,2.35,4.83,3.1l0.42-0.26l0,0c-0.03-0.03-0.06-0.05-0.09-0.07
	c-1.39-0.66-7-3.32-5.12-5.35c0.2-0.2-0.12-0.53-0.31-0.31C26.79,26.5,26.91,27.78,27.77,28.51z"
      />
      <path
        style={{ fill: '#333333' }}
        d="M7.77,28.97c1.26-0.47,2.18-1.12,3.51-1.36c0.91,0.26,1.45,1.21,1.19,2.12c-0.06,0.21-0.16,0.41-0.29,0.58
	c-0.78,0.59-1.76,0.67-2.74,0.66c-0.39-0.01-0.67,0.25-1.05,0.31C8.49,30,8.74,29.99,7.77,28.97z"
      />
      <path
        style={{ fill: '#666666' }}
        d="M7.4,28.69L7.4,28.69c1.26-0.47,2.56-0.83,3.88-1.07c0.91,0.26,1.45,1.21,1.19,2.12
	c-0.06,0.21-0.16,0.41-0.29,0.58c-0.78,0.59-1.73,0.9-2.7,0.9c-0.4-0.01-0.79,0.02-1.18,0.09c0.14,0.58,0.14,1.18,0,1.76
	c0,0.18-0.18,0.59,0,0.78c0.5,0.48,2.26-1.49,5.42-2.32c1.87-0.5,3.86,0,3.85-0.81c-1.33-2.55-2.12-5.34-2.31-8.21
	c-3.34,1.24-6.69,1.65-10,2.84C6.08,26.39,6.8,27.51,7.4,28.69z"
      />
      <path
        style={{ fill: '#444444' }}
        d="M15.34,25.84c0.45,1.25,0.91,2.49,1.4,3.71c0,0.11,0.51,1,0.44,1.08s-0.54,0.12-0.7,0.13
	c-0.5,0-1,0.07-1.5,0.14c-1.17,0.18-2.32,0.52-3.4,1c-0.4,0.18-0.8,0.37-1.18,0.58c-0.59,0.33-1.24,1-1.94,1
	c-0.32,0-0.32,0.51,0,0.5c0.48-0.02,0.93-0.19,1.3-0.5c0.74-0.49,1.52-0.9,2.34-1.24c1.54-0.54,3.14-0.85,4.77-0.94
	c0.61-0.07,0.86-0.11,0.79-0.74c-0.21-0.75-0.5-1.48-0.86-2.17c-0.34-0.87-0.66-1.74-1-2.62c-0.11-0.3-0.59-0.17-0.49,0.13
	L15.34,25.84z"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="35.58"
        cy="23.33"
        rx="0.45"
        ry="1.58"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="34.23"
        cy="23.11"
        rx="0.45"
        ry="1.8"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="27.03"
        cy="23.11"
        rx="0.45"
        ry="1.8"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="25.23"
        cy="23.11"
        rx="0.45"
        ry="1.8"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="23.43"
        cy="23.56"
        rx="0.45"
        ry="1.35"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="21.63"
        cy="24.46"
        rx="0.45"
        ry="1.35"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="19.83"
        cy="24.91"
        rx="0.45"
        ry="0.9"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="32.43"
        cy="22.66"
        rx="0.45"
        ry="2.25"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="30.63"
        cy="22.66"
        rx="0.45"
        ry="2.25"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="28.83"
        cy="22.66"
        rx="0.45"
        ry="2.25"
      />
      <path
        style={{ fill: '#444444' }}
        d="M27.48,35.02c-0.08,0-0.17-0.04-0.21-0.12c-0.07-0.12-0.04-0.27,0.08-0.34l7.06-4.33
	c-0.13-0.45-0.59-1.71-1.91-2.15c-1.83-0.62-2.91-1.14-3.42-2.13c-0.06-0.12-0.01-0.27,0.11-0.34c0.13-0.06,0.28-0.01,0.34,0.11
	c0.43,0.84,1.44,1.31,3.14,1.89c1.9,0.64,2.27,2.62,2.29,2.7c0.02,0.1-0.03,0.2-0.12,0.26l-7.22,4.42
	C27.57,35.01,27.52,35.02,27.48,35.02z"
      />
      <path
        style={{ fill: '#444444' }}
        d="M20.43,29.55c-0.07,0-0.14-0.03-0.18-0.08c-0.02-0.02-0.45-0.51-0.35-1.25c0.1-0.69,0.64-1.34,1.6-1.93
	c2.44-1.49,7.16-0.95,7.36-0.93c0.07,0,2.37,0,3.23,0.06c0.39,0.03,0.88,0.06,1.47,0.12c2.13,0.19,3.46-0.31,3.47-0.31
	c0.13-0.05,0.27,0.01,0.32,0.14c0.05,0.13-0.01,0.27-0.14,0.32c-0.06,0.02-1.43,0.54-3.69,0.34c-0.59-0.05-1.07-0.09-1.46-0.12
	c-0.85-0.06-3.2-0.06-3.23-0.06c-0.08-0.01-4.78-0.54-7.07,0.86c-0.81,0.49-1.28,1.03-1.36,1.56c-0.08,0.5,0.21,0.84,0.22,0.85
	c0.09,0.1,0.08,0.26-0.02,0.35C20.55,29.53,20.49,29.55,20.43,29.55z"
      />
      <path
        style={{ fill: '#333333' }}
        d="M6.34,27.6c-1.1-0.81-1.51-2.27-1-3.54C5.91,22.83,6.8,21.78,7.91,21c3.57-3.13,7.75-5.48,12.28-6.91
	c4.56-1.42,9.48-1.18,13.88,0.69c1.01,0.49,1.99,1.04,2.94,1.64c1.75,0.85,3.25,2.14,4.36,3.73c0.44,0.66,0.61,1.47,0.48,2.25
	c-0.29,0.88-0.91,1.62-1.73,2.06c-0.88,0.62-1.92,0.97-3,1v-0.25c0.48-0.88,0.58-1.92,0.27-2.87c-0.33-0.77-0.92-1.39-1.67-1.75
	c-0.75-0.35-1.54-0.6-2.36-0.72c-2.09-0.44-4.25-0.47-6.35-0.08c-3,0.64-5.66,2.5-8.66,3.26c-0.6,0.17-1.22,0.24-1.84,0.22
	c-1.11-0.07-2.19-0.59-3.29-0.44c-1.42,0.2-2.43,1.43-3.32,2.55s-2,2.29-3.44,2.31L6.34,27.6z"
      />
      <path
        style={{ fill: '#333333' }}
        d="M6.46,27.38c-1.74-1.22-1-3.48,0.16-4.8c1.14-1.2,2.41-2.26,3.79-3.18c2.4-1.79,5.02-3.25,7.81-4.35
	c2.93-1.14,6.07-1.67,9.22-1.54c3.28,0.21,6.46,1.24,9.24,3c2.34,1.39,7.37,4.8,3.6,7.54c-0.63,0.44-1.32,0.77-2.05,1
	c0,0-0.86,0.29-0.88,0.28s0.3-0.87,0.29-0.86c0.31-0.98,0.16-2.05-0.41-2.91c-1.36-1.94-4.43-2.16-6.59-2.28
	c-2.73-0.07-5.43,0.54-7.87,1.77c-1.55,0.81-3.2,1.42-4.9,1.84c-1.67,0.32-3.22-0.62-4.85-0.28c-1.13,0.33-2.12,1.04-2.8,2
	c-0.45,0.58-0.92,1.13-1.43,1.65c-0.45,0.43-1.65,1.48-2.33,1.09c-0.12-0.07-0.28-0.03-0.35,0.1c-0.07,0.12-0.03,0.28,0.1,0.34
	c1.77,1,3.94-2.42,4.85-3.38c0.64-0.8,1.59-1.3,2.61-1.39c0.82,0.09,1.63,0.23,2.43,0.42c1.5,0.09,2.99-0.2,4.35-0.84
	c3.26-1.28,6.12-3,9.74-2.85c1.85-0.07,3.68,0.27,5.38,1c1.07,0.5,1.75,1.59,1.73,2.77c0,0.67-0.48,1.22-0.44,1.88
	c0,0.14,0.11,0.25,0.25,0.25c2.93-0.11,6.24-2.6,4.48-5.7c-0.96-1.41-2.26-2.56-3.78-3.35c-1.77-1.16-3.68-2.1-5.68-2.79
	c-8.14-2.52-16.58,1-23,5.93c-1.48,1.15-3.31,2.42-4,4.26c-0.55,1.37-0.11,2.94,1.08,3.82C6.48,28,6.73,27.57,6.46,27.38z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M7.4,28.69c0,0,0.22,0.48,0.39,0.6s0.56,0.41,0.56,0.41s0.22-0.82,0.46-0.93c0.06-0.03,0.78,0.27,0.78,0.27
	s0.21-0.64,0.52-0.73c0.14-0.04,0.69,0.26,0.69,0.26s0.2-0.49,0.39-0.51c0.15-0.02,0.28-0.02,0.38,0.01
	c0.57,0.14,0.57,0.14,0.57,0.14s-0.45-0.62-0.87-0.57c-0.41,0.05-1.75,0.36-2.26,0.53S7.4,28.69,7.4,28.69z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M8.41,30.85c0-0.21,0-0.5,0-0.5s0.82,0.4,1.12,0.43c0.16,0.02,0.53-0.6,0.53-0.6s0.61,0.29,0.83,0.31
	c0.12,0.01,0.34-0.48,0.34-0.48l0.95,0.3c0,0-0.91,0.66-1.64,0.78c-0.73,0.11-1.58,0.09-1.9,0.15S8.31,31.3,8.31,31.3
	S8.41,31.05,8.41,30.85z"
      />
    </>
  </AvatarArtwork>
);

export default XenomorphAvatarArtwork;
